import { getUserToken } from '@this+that/app-config';
import axios from 'axios';

export const createApiWithAuth = (baseURL: string) => {
  const api = axios.create({ baseURL });

  api.interceptors.request.use(
    async (config) => {
      const token = await getUserToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return api;
};
